import { makeStyles } from "@mui/styles";
import theme from "src/theme";

export const useStyles = makeStyles({
    "@global": {
        "@keyframes betRankDropdownOptionLabel": {
            "0%": {
                transform: "scale(1)",
            },
            "50%": {
                transform: "scale(1.2)",
            },
            "100%": {
                transform: "scale(1)",
            },
        },
    },
    betSelectLabelWrapper: {
        width: "100%",
        display: "flex",
        alignItems: "center",
    },
    betSelectLabelIcon: {
        width: 24,
        height: 24,
        marginRight: 8,
    },
    betSelectLabel: {
        fontWeight: 700,
        fontSize: 24,
        textShadow: "1px 1px 0px 0px rgba(31, 29, 25, 1)",
        background:
            "linear-gradient(180deg, #FF9604 -0.31%, #FFE522 11.9%, #FFFFC1 36.23%, #FFBB1B 65.11%, #E28800 65.12%, #E9A600 88.87%)",
        "-webkit-background-clip": "text",
        "-webkit-text-fill-color": "transparent",
    },
    betSelectLabelFree: {
        textShadow: "1px 1px 0px 0px rgba(255, 255, 255, 1)",
        background:
            "linear-gradient(180deg, #DDDDDD -0.31%, #EEEEEE 11.9%, #FFFFFF 36.23%, #FCFCFC 65.11%, #E2E2E2 65.12%, #AAAAAA 88.87%)",
        "-webkit-background-clip": "text",
        "-webkit-text-fill-color": "transparent",
    },
    betSelectIcon: {
        width: "100%",
        height: "100%",
        objectFit: "contain",
    },
    betOption: {
        alignItems: "center",
        width: "100%",
        color: "rgba(245, 245, 245, 0.9)",
        padding: "9px 12px",
        display: "grid",
        justifyСontent: "flex-start",
        gridTemplateColumns: "minmax(20px, 30px) 1fr auto",
        [theme.breakpoints.down("xl")]: {
            padding: "3px 5px",
        },
    },
    betOptionSelected: {
        color: "rgba(245, 245, 245, 0.9)",
        background: "rgba(0, 186, 108, 0.1)",
    },
    betDropdownOptionIcon: {
        width: 16,
        height: 16,
        opacity: 0.5,
        marginRight: 5,
    },
    betDropdownOptionIconSelected: {
        opacity: 1,
    },
    betDropdownOptionLabel: {
        fontSize: 16,
        fontWeight: 500,
        color: "rgba(245, 245, 245, 0.9)",
        [theme.breakpoints.down("xl")]: {
            fontSize: "15px",
            letterSpacing: "-0.5px",
        },
    },

    betRankDropdownOptionLabel: {
        width: "100%",
        height: "100%",
        overflow: "hidden",
        whiteSpace: "nowrap",
        textOverflow: "ellipsis",
        "&.percent ": {
            textOverflow: "clip",
        },
        [theme.breakpoints.down("xl")]: {
            fontSize: "13px",
            letterSpacing: "-0.5px",
        },
        animationName: "betRankDropdownOptionLabel",
        animationIterationCount: "infinite",
        animationFillMode: "forwards",
        animationDuration: "8000ms",
        animationDelay: "0.5s",
    },
});
